import { Component, OnInit } from '@angular/core';
import { TipoOperacion } from 'src/app/home/_models/tipo-operacion';
import { SharedModule } from 'src/app/_shared/_shared.module';
import { SellosComponent } from 'src/app/factoring/shared/utils/sellos/sellos.component';
import { RouterModule } from '@angular/router';
import { CifrasWebSego } from 'src/app/home/_models/cifras-web-sego';
import { MatSnackBar } from '@angular/material/snack-bar';
import { CifrasWebSegoService } from 'src/app/home/_services/cifras-web-sego.service';
import { SnackBarErrorConfig } from 'src/app/_utils/_material-import/snackbar-config';

@Component({
  selector: 'app-tipos-operaciones',
  standalone: true,
  imports: [SharedModule, SellosComponent, RouterModule],
  templateUrl: './tipos-operaciones.component.html',
  styleUrls: ['./tipos-operaciones.component.scss']
})
export class TiposOperacionesComponent implements OnInit
{
  isLoading: boolean = false;
  cifrasWeb: CifrasWebSego;
  operacionesData: TipoOperacion[];
  
  constructor(
    private _matSnackBar: MatSnackBar,
    private _cifrasWebService: CifrasWebSegoService
  ) { }

  ngOnInit(): void
  {
    this.getCifrasWeb();
  }

  private getCifrasWeb(): void{
    this.isLoading = true;
    this._cifrasWebService.getCifrasSegoWeb().subscribe({
      next: (r) => {
        this.isLoading = false;
        this.cifrasWeb = r;
      },
      complete: () => {
        this.getFichaOperacionesData();
      },
      error: (e) => {
        this.isLoading = false;
        this._matSnackBar.open(this._cifrasWebService.getServerErrors(e), 'x', new SnackBarErrorConfig());
      }
    });
  }

  private getFichaOperacionesData(): void
  {
    this.operacionesData = [
      { tipoOperacionCodigo: 'con-seguro', titulo: 'Con Seguro', tipoPerfil: 'Perfil Conservador', renta: this.cifrasWeb.rentabilidadAnualAseguradas + ' Rent. Anualizada' },
      { tipoOperacionCodigo: 'sin-seguro', titulo: 'Sin Seguro', tipoPerfil: 'Perfil Moderado', renta: this.cifrasWeb.rentabilidadAnualNoAseguradas + ' Rent. Anualizada' },
      { tipoOperacionCodigo: 'admin-publica', titulo: 'Admón. Pública', tipoPerfil: 'Perfil Equilibrado', renta: this.cifrasWeb.rentabilidadAnualAdminPublica + ' Rent. Anualizada' },
    ];
  }
}
